// src/lightTheme.ts
//
// Thin entry point kept for backward-compatible imports. The real theme lives in
// src/theme/createAppTheme.ts (shared typography/components/custom) and
// src/theme/palette.ts (lightPalette). The MUI module augmentation is declared
// globally in src/types/theme.d.ts.
//
// The app is light-only (F-P3-006): no <Admin> darkTheme, no user-facing
// dark mode toggle. createAppTheme stays internally mode-aware because
// ArrivalsWallScreen.tsx (the authenticated "pantalla de pared") has its own,
// unrelated per-hotel `wall.theme` display setting that can render dark — that
// is a deliberate always-dark display, not a user dark-mode preference, and is
// out of this unit's scope; it calls createAppTheme('dark') directly.
import { createAppTheme } from './theme/createAppTheme';

export const lightTheme = createAppTheme('light');

export default lightTheme;
